import { Control, Controller, useWatch } from 'react-hook-form';
import { UseFormSetValue } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../common';
import { Card, Input, Radio, Select } from 'antd';
import { CircleDollarSign } from 'lucide-react';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../form-label';
import {
  MEMBER_PAYMENT_ACCOUNT_TYPE_MAP,
  PaymentMethod,
} from 'constants/RecyclingConsignment';
import { SHOP_MAP } from 'constant/shop';

const PaymentInfo = ({
  control,
  setValue,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  setValue: UseFormSetValue<CreateRecyclingConsignmentOrderV2SchemaType>;
}) => {
  const settlementType = useWatch({ control, name: 'settlementType' });
  const storeId = useWatch({
    control,
    name: 'storeId',
  });
  const isHongKongStore = storeId === SHOP_MAP.HONGKONG;

  return (
    <Card bodyStyle={{ padding: '16px' }}>
      <div className="space-y-4">
        <div className="flex items-center gap-2 text-base font-medium">
          <CircleDollarSign className="w-5 h-5" />
          {i18n.t(LOCALS.payment_info_2)}
        </div>

        <div className="flex items-center gap-2">
          <FormLabel required>{i18n.t(LOCALS.payment_method)}:</FormLabel>
          <Controller
            name="settlementType"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                  if (e === 2) {
                    setValue(
                      'memberPaymentAccountType',
                      MEMBER_PAYMENT_ACCOUNT_TYPE_MAP.JP,
                    );
                  } else {
                    setValue('memberPaymentAccountType', undefined);
                  }
                }}
                options={PaymentMethod}
                className="w-full"
              />
            )}
          />
        </div>

        {isHongKongStore && (
          <div className="flex items-center gap-2">
            <FormLabel required>{i18n.t(LOCALS.is_trade_in)}:</FormLabel>
            <Controller
              name="isTradeIn"
              control={control}
              render={({ field }) => (
                <Radio.Group
                  {...field}
                  optionType="button"
                  buttonStyle="solid"
                  options={[
                    { label: i18n.t(LOCALS.no), value: 0 },
                    { label: i18n.t(LOCALS.yes), value: 1 },
                  ]}
                />
              )}
            />
          </div>
        )}

        {settlementType === 2 && (
          <div className="flex items-center gap-2">
            <FormLabel className="shrink-0 self-start">{i18n.t(LOCALS.payment_details)}:</FormLabel>
            <Controller
              name="payoutDetail"
              control={control}
              render={({ field }) => (
                <Input.TextArea
                  {...field}
                  className="w-full"
                  autoSize={{ minRows: 4, maxRows: 6 }}
                  placeholder={i18n.t(LOCALS.please_enter) || ''}
                />
              )}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default PaymentInfo;
